export default "__VITE_ASSET__D6KK4J3x__"